import React, { useState, useEffect } from "react";
import { Button, Table, Row, Col, Form, Spinner, Dropdown, Alert } from "react-bootstrap";
import DashLayout from "../functionalComponents/DashboardLayout/DashboardLayout";
import DashRouters from "../../configs/routers/dashboard-routers.json";
import Drawer from "./Drawer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faSearch } from "@fortawesome/free-solid-svg-icons";
import devIcon from '../../assets/img/ui_icons/devportal.png';
import ObexRequestHandler from "../../handlers/ObexRequestsHandler";
import SessionService from "../../services/SessionsService";

import UnitTestForm from "./Publisher_unitTest";
import DocumentationForm from "./Publisher_documentation";
import FileUpload from "./components/uploadFile";
import { useHistory } from "react-router-dom";
import Nodata from "./components/Nodata";

const DevPortalApps = () => {
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [SelectedPProductId, setSelectedPProductId] = useState('');
  const [apis, setApis] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [apiProducts, setApiProducts] = useState([]);
  const [loadingApiProducts, setLoadingApiProducts] = useState(false);
  const [isDocumentationDrawerOpen, setIsDocumentationDrawerOpen] = useState(false);
  const [isUnittestDrawerOpen, setIsUnittestDrawerOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [jsonContent, setJsonContent] = useState(null);
  const [selectedApiForUnittest, setSelectedApiForUnittest] = useState(null);

  const [localEmail, setEmail] = useState('');
  const [localPassword, setPassword] = useState('');
  const [mustChange, setMustChange] = useState(false);
  const history = useHistory();

  ///custon upload file
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelect = (file) => {
    setSelectedFile(file); 
};


const AMBIENT_LABELS = {
  Active: { name: 'Active', color: '#2AA366' },        // Verde
  Disabled: { name: 'Disabled', color: '#FF6F5C' }, // Amarillo
  Blocked: { name: 'Blocked', color: '#EDA944' }, // Amarillo
  UnBlocked: { name: 'UnBlocked', color: '#2AA366' }, // Amarillo

};

const getAmbientLabel = (ambientId: string) => {
  const ambient = AMBIENT_LABELS[ambientId];
  if (!ambient) return null;

  return (
    <span 
      style={{
        backgroundColor: ambient.color,
        color: '#fff',
        padding: '2px 4px',
        borderRadius: '4px',
        fontSize: '12px',
        minWidth:'100px',
        display:'flex',
        width:'65px',
        justifyContent:'center',
        marginLeft:'auto',
        marginRight:'auto',
      }}
    >
      {ambient.name}
    </span>
  );
};


const handleDeleteProxy = async (proxy) => {
 // if (window.confirm('Are you sure you want to delete this App?')) {

    console.log(proxy);
    //setProxies(proxies.filter((proxy) => proxy.id !== id));
    const payload = {
      devportal_id: selectedProjectId, 
      app_id: proxy.app_id
    }
    console.log(payload);
    await ObexRequestHandler.post('/publishing/delete_dev_portal_app', payload)
//  }
  fetchProjects();
};


const handleDeactiveProxy = async (proxy) => {
   

    console.log(proxy);
    //setProxies(proxies.filter((proxy) => proxy.id !== id));
    const payload = {
      devportal_id: selectedProjectId, 
      app_id: proxy.app_id
    }

    console.log(payload);
    const rerr = await ObexRequestHandler.post('/publishing/deactivate_dev_portal_app', payload)
    console.log(rerr)
  fetchProjects();
  fetchApisByProject();
};


const handleActiveProxy = async (proxy) => {
   

  console.log(proxy);
  //setProxies(proxies.filter((proxy) => proxy.id !== id));
  const payload = {
    devportal_id: selectedProjectId, 
    app_id: proxy.app_id
  }
  console.log(payload);
  await ObexRequestHandler.post('/publishing/activate_dev_portal_app', payload)

fetchProjects();
fetchApisByProject();
};


const handleBlockProxy = async (proxy) => {
   

  console.log(proxy);
  //setProxies(proxies.filter((proxy) => proxy.id !== id));
  const payload = {
    devportal_id: selectedProjectId, 
    app_id: proxy.app_id
  }
  console.log(payload);
  await ObexRequestHandler.post('/publishing/block_dev_portal_app', payload)

fetchProjects();
fetchApisByProject();
};


const handleUnBlockProxy = async (proxy) => {
   

  console.log(proxy);
  //setProxies(proxies.filter((proxy) => proxy.id !== id));
  const payload = {
    devportal_id: selectedProjectId, 
    app_id: proxy.app_id
  }
  console.log(payload);
  await ObexRequestHandler.post('/publishing/unblock_dev_portal_app', payload)

fetchProjects();
fetchApisByProject();
};



  const openDocumentationDrawer = () => {
    setIsDocumentationDrawerOpen(true);
  };

  const closeDocumentationDrawer = () => {
    setIsDocumentationDrawerOpen(false);
  };

  const openUnittestDrawer = () => {
    setIsUnittestDrawerOpen(true);
  };

  const closeUnittestDrawer = () => {
    setIsUnittestDrawerOpen(false);
  };

  const fetchProjects = async () => {
    setLoading(true);
    setProjects([]);
    try {
      const response = await ObexRequestHandler.get(`/gateway/get_dev_portal_by_org?org_id=${SessionService.ORGANIZATION}`, {}, true)
      const projectsInfo = response.data || [];
      setProjects(projectsInfo);
      console.log(projectsInfo);
      if (projectsInfo.length>0){
      setSelectedProjectId(projectsInfo[0].id)
      fetchAPIProducts(projectsInfo[0].id)
      } else {
        //setApiProducts([]);
        setApis([])
      }
      history.push('/dev_portals_apps')
      
    } catch (error) {
      console.error('Error fetching projects:', error);
      
    }
    history.push('/dev_portals_apps')
    setLoading(false);
    
  };


  const fetchAPIProducts = async (projects_id) => {
    try {
      const response = await ObexRequestHandler.get(`/publishing/get_dev_portal_apps/${projects_id}`, {}, true
      );
      const publishedApis = response.data || {};
      const products = publishedApis.Products || [];

      if (products.length === 0) {
        console.warn('No API Products found for the selected project.');
      }

      setApiProducts(products.map((product) => ({ id: product.id, name: product.name })));
      setInitialized(true);
    } catch (error) {
      setInitialized(true);
      console.error('Error fetching API Products:', error);
      setApiProducts([]);
      setInitialized(true);
    } finally {
      setLoadingApiProducts(false);
      setInitialized(true);
    }
    setInitialized(true);
  }


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;

    if (file && file.type === 'application/json') {
      const reader = new FileReader();

      reader.onload = () => {
        // Comprobamos si el resultado es una cadena
        const fileContent = reader.result;
        if (typeof fileContent === 'string') {
          try {
            const json = JSON.parse(fileContent);
            setJsonContent(json); // Asigna el contenido JSON a la variable
          } catch (error) {
            alert('El archivo no es un JSON válido');
          }
        } else {
          alert('El archivo no es un formato adecuado');
        }
      };

      reader.readAsText(file); // Lee el archivo como texto
    } else {
      alert('Por favor, seleccione un archivo JSON');
    }
  };



  const handleSubmitUser = async (e) => {
    e.preventDefault();

    const payload = {
                      devportal_id: selectedProjectId,
                      username: localEmail,
                      password: localPassword,
                      active: true
                    }

    await ObexRequestHandler.post('/publishing/add_dev_portal_user', payload)

    fetchApisByProject();

    closeDrawer();


  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Formulario enviado con el proyecto seleccionado:', selectedProjectId);
    console.log('Formulario enviado con el api product seleccionado:', SelectedPProductId);
    console.log('Contenido del archivo JSON:', jsonContent);

    //let url_service = `${cloud}/gateway/routing/add_gateway_link?obex_project_id=${SelectedProject}`

    //custom file
    const formData = new FormData();
    formData.append("file", selectedFile); // logica para subir el archivo

    const payload = {
      api_product_id: SelectedPProductId,
      my_api: jsonContent
      

    }

    await ObexRequestHandler.post(`/gateway/routing/add_gateway_link?obex_project_id=${selectedProjectId}`, payload)

    fetchApisByProject();

    closeDrawer();

  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    setSelectedProjectId(value);
    await fetchAPIProducts(value);
    console.log(name, value);
  }

  const handleChangeProduct = async (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    setSelectedPProductId(value);
    console.log(name, value);
  }

  const handlePublish = async (api) =>{
 
    const payload = {
      gateway_id: api.gateway_id, 
      new_status: !api.is_published, 
      api_id: api.api_id, 
      api_product_id: api.api_product_id
    }

    await ObexRequestHandler.post('/update_portal_apis_status', payload);

    fetchApisByProject();

    //update_portal_apis_status
  }

  const fetchApisByProject = async () => {
    if (!selectedProjectId) return;

    setLoading(true);
    try {
      const response = await ObexRequestHandler.get(`/publishing/get_dev_portal_apps/${selectedProjectId}`, {}, true);
      console.log('Response from publishing/get_dev_portal_users', response);
      const data = response.data || [];

      const dataFiltered = []
      console.log(data);
      data.forEach(element => {
        if (element.api_id){
          if (element.has_documentation_entry	!== 'No') dataFiltered.push(element); else dataFiltered.push(element);
        } else dataFiltered.push(element);
      });

      console.log(".-------.")
      console.log(dataFiltered);
      console.log(".-------.")

      setApis(dataFiltered);
    } catch (error) {
      console.error('Error fetching APIs by project:', error);
    }
    setLoading(false);
  };


  document.addEventListener('updateView', (e) => {
    if (SessionService.updating>0 && location.pathname == '/dev_portals_apps'){
      history.push('/dev_portals_apps')
      SessionService.updating = SessionService.updating -3;
      fetchProjects();
    window.scrollTo(0, 0);
    history.push('/dev_portals_apps')
    }
  
  }, false);




  useEffect(() => {
    fetchProjects();
    function manejarUpdateView(event) {
      // Lógica para manejar el evento SessionService.updateView
      console.log('Evento SessionService.updateView capturado');
    }
    // Añadir listener al montar el componente
    document.addEventListener('updateView', manejarUpdateView);

    // Remover listener al desmontar el componente
    return () => {
      document.removeEventListener('updateView', manejarUpdateView);
    };
  }, []);



  const openDrawer = (role) => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleEditUnittest = (api) => {
    setSelectedApiForUnittest(api);
    openUnittestDrawer();
  };


  useEffect(() => {
    if (selectedProjectId) {
      fetchApisByProject();
    } else {
      setApis([]);
    }
  }, [selectedProjectId]);

  const filteredApis = apis.filter(api =>
    api.app_name?.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
    <DashLayout sider={DashRouters} active={'api-publisher'} sublinks={[]}>
      <Row id='topHeader'>
        <Col md='8' >
          <div className='d-flex flex-column'>
            <div className="cld_wrapperTitle">
              <img src={devIcon} alt="icon dashboard" />
             
              <span className="cld_title w-100 margin-y-24px">
                
                <span className="cld_index">Dev Portal </span>/ Apps 
                <p className="title_description">This is Dev Portal Apps</p>
                </span>
            </div>

          </div>
        </Col>




        <Col md='4' className='align-content-center'>


{/*}
          <Button style={{ width: '225px' }} className="customButton-blue px-4 float-right  resBtn" onClick={() => openDrawer(null)}>
            Add User
          </Button>
*/}
        

          {/* Botón opcional  */}
        </Col>
        <Col>
          <div className="customBorder"></div>
        </Col>
      </Row>

      <div className="mt-5"></div>

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <div className="cld_borderWrapper">
          {/*<span className='cld_sectionTitle'>Select a Developer Portal</span>*/}

          <div style={{display:'flex'}}>

          <Form.Group  className="my-4" style={{width:'100%'}}>
            <Form.Control as="select" onChange={(e) => setSelectedProjectId(e.target.value)} value={selectedProjectId || ''}>
              <option value="">-- Select a project --</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.description}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <div className="searchContainerHalf mb-4" style={{ position:'relative', marginLeft:'5%', width:'90%', marginTop:'24px' }}>
                <Form.Control
                  id='buscador'
                  required
                  type="text"
                  value={searchTerm}
                  placeholder="Search by APP name"
                  style={{marginRight:'calc(-10% - 20px)'}}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button className="customButton-transparent-half px-4">
                  <FontAwesomeIcon icon={faSearch} size="1x" />
                </Button>
              </div>

    </div>

    {((!selectedProjectId || apis.length === 0 || filteredApis.length === 0) && initialized) ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
              <Nodata />
            </div>
          ) : (
            <>
              

              <Table className="cld_tableWrapper" responsive>
                <tbody>
                  <tr className="headerRow">
                    <th style={{ width: '20%' }} className="textBold">App Name</th>
                    <th style={{ width: '20%' }} className="textBold">User</th>
                    <th style={{ width: '10%' }} className="textBold">API Products</th>
                    <th style={{ textAlign:'center', width: '20%' }} className="textBold">Status</th>
                    <th style={{ width: '20%' }} className="textBold">APP Tokens</th>
                    <th style={{ textAlign: 'end', width: '20px' }} className="textBold">Actions</th>
                  </tr>
                  {filteredApis.map((api, index) => (
                    <tr className="tableRow" key={index}>
                      <td className="td_centered">{api.app_name || '-'}</td>
                      <td className="td_centered">{api.user_username ? api.user_username : '-'}</td>
                      <td className="td_centered">{api.api_products ? api.api_products.map(prr=>(prr.product_name)).join('\n'): '-'}</td>
                      <td style={{ textAlign:'center' }}  className="td_centered">{!api.app_blocked ? getAmbientLabel(api.app_active ? 'Active':'Disabled') : getAmbientLabel('Blocked')}</td>
                      <td className="td_centered">{api.tokens ? api.tokens.map(prr => prr.token).join('\n') : '-'}</td>
                      <td>
                        <div className="actionsWrapper d-flex justify-content-center align-items-center h-100">
                          <Dropdown className='my-auto'  style={{ marginRight:'2px' }}>
                            <Dropdown.Toggle variant="" className="icon-edit-table">
                              <FontAwesomeIcon className="icon-edit-table"
                              icon={faEllipsisV} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>


{/*}
                            <Dropdown.Item
                                    key={1}
                                    onClick={openDocumentationDrawer}
                                  >
                                    Edit App
                                  </Dropdown.Item>

                                  */}
                                  <Dropdown.Item
                                    key={1}
                                    onClick={() => handleDeleteProxy(api)}
                                  >
                                    Delete App
                                  </Dropdown.Item>

                                { api.app_active ?
                                  <Dropdown.Item
                                    key={1}
                                    onClick={() => handleDeactiveProxy(api)}
                                  >
                                    Disable App
                                  </Dropdown.Item>
                                  :
                                  <Dropdown.Item
                                    key={1}
                                    onClick={() => handleActiveProxy(api)}
                                  >
                                    Enable App
                                  </Dropdown.Item>
                                  }

{ api.app_blocked ?
                                  <Dropdown.Item
                                    key={1}
                                    onClick={() => handleUnBlockProxy(api)}
                                  >
                                    UnBlock App
                                  </Dropdown.Item>
:
                                  <Dropdown.Item
                                    key={1}
                                    onClick={() => handleBlockProxy(api)}
                                  >
                                    Block App
                                  </Dropdown.Item>

}

                                  
                            </Dropdown.Menu>


                          </Dropdown>
                        </div>
                      </td>
                    </tr>
                  ))}
{/*}
                                    {filteredApis.length < 3 &&
                                      <div style={{ height:'65px' }}></div>
                                    }
                                      */}
                </tbody>
              </Table>
            </>
          )}
        </div>
      )}


      <Drawer
      index=""
        toggleSidebar={closeDrawer}
        isOpen={isDrawerOpen}
        name={'Add User to Dev Portal'}
        subtitle=''
      >


        <Form onSubmit={handleSubmitUser}>
          <Form.Group controlId="project">
            <Form.Label>Available Dev Portals</Form.Label>
            <Form.Control
              as="select"
              name="project"
              value={selectedProjectId}
              onChange={handleChange}
            >
              <option value="">Select a dev portal</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.description}
                </option>
              ))}
            </Form.Control>
          </Form.Group>



                <Form.Group controlId="basePath" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter email"
                    value={localEmail}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>



                <Form.Group controlId="basePath" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={localPassword}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>


        <Form.Check
          type="checkbox"
          label="Password must change"
          checked={mustChange}
          onChange={(e) => setMustChange(e.target.checked)}
        />
       <Row>
            <div style={{ height:'2em' }}></div>
       </Row>
      {/*}

          {selectedProjectId &&
            <><Row>
              <Form.Group controlId="file" style={{ paddingLeft: '15px', paddingRight: '15px', width: '100%' }}>
                <Form.Label>OpenAPI Spec File</Form.Label>
                <FileUpload
                    onFileSelect={handleFileSelect}
                    allowedTypes={['application/json']}
                    label="Select a JSON file"
                />

              </Form.Group>
             



            </Row> </>
          }
            */}
              
                <Row>
                  <Col md="12" style={{textAlign:'end'}} >
                    <Button type="submit" variant="primary" className="w-100"
                                    style={{
                    backgroundColor:'var(--color-btn-green)',
                    borderBlockColor:'var(--color-btn-green)',
                    borderStyle:'none',
                    paddingTop:'2px',
                    paddingBottom:'2px',
                    paddingLeft:'15px',
                    paddingRight:'15px',
                    fontSize:'15px',
                    maxWidth:'100px'
                    }}>
                      Create
                    </Button>
                  </Col>
                </Row>
             
           
          
        </Form>

      </Drawer>

      <Drawer
        index=""
        toggleSidebar={closeDocumentationDrawer}
        isOpen={isDocumentationDrawerOpen}
        name="Edit Documentation"
        subtitle=""
      >
      <DocumentationForm documenta={''} obex_project_id={undefined} docInfo={undefined} api_product_id={undefined}></DocumentationForm>
      </Drawer>

      <Drawer
        index=""
        toggleSidebar={closeUnittestDrawer}
        isOpen={isUnittestDrawerOpen}
        name="Edit Unittest"
        subtitle=""
      >
        	<UnitTestForm apiDetails={selectedApiForUnittest} onClose={closeUnittestDrawer} />
      </Drawer>
    </DashLayout>
  );
};

export default DevPortalApps;
